
let token = null;

export function setToken(newToken) {
    token = newToken;
};

export function getToken() {
    return token;
};

